import {
  Description,
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  Tab,
  TabGroup,
  TabList,
  TabPanel,
} from "@headlessui/react";
import { X } from "lucide-react";
import { Fragment } from "react/jsx-runtime";
import type TabView from "../../types/ui/TabView";
import AccountSetup from "./AccountSetup";

export default function ConfigureSettings({
  isLinkingNewAccount,
  isNewAccountLinked,
  onClose,
}: {
  isLinkingNewAccount: boolean;
  isNewAccountLinked: boolean;
  onClose: () => void;
}) {
  const tabViews: TabView[] = [
    {
      Id: 1,
      Name: "Account setup",
      Element: (
        <AccountSetup
          isLinkingNewAccount={isLinkingNewAccount}
          isNewAccountLinked={isNewAccountLinked}
        />
      ),
    },
  ];

  return (
    <>
      <Dialog
        as="div"
        open={true}
        onClose={() => onClose()}
        className="relative z-50"
      >
        <DialogBackdrop
          className="fixed inset-0 bg-black/60"
          aria-hidden="true"
        />

        <div className="fixed inset-8 flex items-center justify-center rounded-2xl">
          <DialogPanel
            as="div"
            className="grid grid-rows-[auto_1fr] w-300 h-225 rounded-2xl shadow-lg overflow-hidden bg-white border-gray-50"
          >
            <DialogTitle
              as="div"
              className="flex items-center justify-between px-4 py-4 bg-white text-2xl font-medium"
            >
              <h2>Settings</h2>
              <X
                className="h-6 w-6 text-gray-500 hover:cursor-pointer"
                onClick={() => onClose()}
              />
            </DialogTitle>

            <Description as="div">
              <TabGroup as="div" className="flex w-full p-4 pt-0">
                <TabList className="w-[30%] pr-4">
                  {tabViews.map((tab) => (
                    <Tab as={Fragment} key={tab.Id}>
                      {({ selected }) => (
                        <div
                          className={`relative p-3 flex items-center rounded-t-xs text-sm outline-none transition hover:bg-gray-200 hover:cursor-pointer ${
                            selected ? "bg-gray-200" : "font-normal"
                          }`}
                        >
                          {tab.Name}
                        </div>
                      )}
                    </Tab>
                  ))}
                </TabList>

                <div className="w-[68%] p-4 border-gray-200 border rounded">
                  {tabViews.map((tab) => (
                    <TabPanel key={tab.Id}>{tab.Element}</TabPanel>
                  ))}
                </div>
              </TabGroup>
            </Description>
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );
}
